import { __decorate, __metadata } from "tslib";
import { AppRequest } from '@core/shared/app-request';
import { AppRequestMethod } from '@core/shared/request';
import { Expose, Model, ModelId } from '@core/shared/model';
export let GetMaintenanceAnnouncementResponse = /*#__PURE__*/(() => {
  class GetMaintenanceAnnouncementResponse {}
  __decorate([Expose(), __metadata("design:type", String)], GetMaintenanceAnnouncementResponse.prototype, "announcementText", void 0);
  __decorate([Expose(), __metadata("design:type", Date)], GetMaintenanceAnnouncementResponse.prototype, "announcementTime", void 0);
  return GetMaintenanceAnnouncementResponse;
})();
let CheckMaintenanceInfoRequest = /*#__PURE__*/(() => {
  let CheckMaintenanceInfoRequest = class CheckMaintenanceInfoRequest extends Model {
    static {
      this.Response = GetMaintenanceAnnouncementResponse;
    }
  };
  CheckMaintenanceInfoRequest = __decorate([AppRequest('maintenance', 'check-for-maintenance-announcement', {
    httpMethod: AppRequestMethod.GET,
    httpCacheControl: 'no-cache'
  }), ModelId("CheckMaintenanceInfoRequest") // auto-generated by generate-model-ids
  ], CheckMaintenanceInfoRequest);
  return CheckMaintenanceInfoRequest;
})();
export { CheckMaintenanceInfoRequest };